/***** Pannels hover hide & pics ******/

const groupPage = document.querySelector(".group__pannels");
if (groupPage) {
  const imgPannel1 = document.querySelector(".pannel--img1");
  const imgPannel2 = document.querySelector(".pannel--img2");
  const imgPannel3 = document.querySelector(".pannel--img3");
  const imgPannel4 = document.querySelector(".pannel--img4");

  const txtPannel1 = document.querySelector(".pannel--text1");
  const txtPannel2 = document.querySelector(".pannel--text2");
  const txtPannel3 = document.querySelector(".pannel--text3");
  const txtPannel4 = document.querySelector(".pannel--text4");

  txtPannel1.addEventListener("mouseover", () => {
    txtPannel1.classList.add("pannel--hover");
    txtPannel2.classList.remove("pannel--hover");
    txtPannel3.classList.remove("pannel--hover");
    txtPannel4.classList.remove("pannel--hover");

    imgPannel1.classList.add("pannel--hover");
    imgPannel2.classList.remove("pannel--hover");
    imgPannel3.classList.remove("pannel--hover");
    imgPannel4.classList.remove("pannel--hover");
  });

  txtPannel2.addEventListener("mouseover", () => {
    txtPannel1.classList.remove("pannel--hover");
    txtPannel2.classList.add("pannel--hover");
    txtPannel3.classList.remove("pannel--hover");
    txtPannel4.classList.remove("pannel--hover");

    imgPannel1.classList.remove("pannel--hover");
    imgPannel2.classList.add("pannel--hover");
    imgPannel3.classList.remove("pannel--hover");
    imgPannel4.classList.remove("pannel--hover");
  });

  txtPannel3.addEventListener("mouseover", () => {
    txtPannel1.classList.remove("pannel--hover");
    txtPannel2.classList.remove("pannel--hover");
    txtPannel3.classList.add("pannel--hover");
    txtPannel4.classList.remove("pannel--hover");

    imgPannel1.classList.remove("pannel--hover");
    imgPannel2.classList.remove("pannel--hover");
    imgPannel3.classList.add("pannel--hover");
    imgPannel4.classList.remove("pannel--hover");
  });

  txtPannel4.addEventListener("mouseover", () => {
    txtPannel1.classList.remove("pannel--hover");
    txtPannel2.classList.remove("pannel--hover");
    txtPannel3.classList.remove("pannel--hover");
    txtPannel4.classList.add("pannel--hover");

    imgPannel1.classList.remove("pannel--hover");
    imgPannel2.classList.remove("pannel--hover");
    imgPannel3.classList.remove("pannel--hover");
    imgPannel4.classList.add("pannel--hover");
  });
}
